// this reducer stores only the group info

import {createSlice} from '@reduxjs/toolkit';

const initialState = null;

const groupInfoSlice = createSlice({
  name: 'groupInfo',
  initialState,
  reducers: {
    setGroupInfo(state, {payload: groupInfo}) {
      console.log('setGroupInfo fired');
      console.log('setGroupInfo', {groupInfo});
      return groupInfo;
    },
    clearGroupInfo() {
      return null;
      //
    },
  },
});

export const {setGroupInfo, clearGroupInfo} = groupInfoSlice.actions;
export default groupInfoSlice.reducer;
